import { RootState } from '../store';

export const selectIsDemoMode = (state: RootState) => state.demo?.isDemoMode ?? false;
export const selectDemoCurrentStep = (state: RootState) =>
  state.demo?.currentStep ?? 0;
export const selectDemoTotalSteps = (state: RootState) => state.demo?.totalSteps ?? 6;

export const selectDemoListings = (state: RootState) => state.demo?.mockListings ?? [];
export const selectDemoShowings = (state: RootState) => state.demo?.mockShowings ?? [];
export const selectDemoOffers = (state: RootState) => state.demo?.mockOffers ?? [];
export const selectDemoInspections = (state: RootState) =>
  state.demo?.mockInspections ?? [];
export const selectDemoTransactions = (state: RootState) =>
  state.demo?.mockTransactions ?? [];
export const selectDemoStatuses = (state: RootState) => state.demo?.mockStatuses ?? {};
